module.exports = __webpack_public_path__ + "static/media/redux.85772647.svg";